// mockedData.ts
import { ResidentialResponse } from '../types/IdentificationApi/ResidentialResponse';

export const mockedData: Record<string, ResidentialResponse> = {
  '94278965079': {
    data: {
      status: 'CONECTADO'
    }
  },
  '71724684060': {
    data: {
      status: 'CONECTADO'
    }
  },
  '71870208056': {
    data: {
      status: 'NÃO ENCONTRADO'
    }  
  },
  '51944045066': {
    data: {
      status: 'NÃO ENCONTRADO'
    } 
  },
  '78701196014': {
    data: {
      status: 'CONECTADO'
    } 
  },
  '30389125067': {
    data: {
      status: 'CONECTADO'
    } 
  },
  '87448761064': {
    data: {
      status: 'NÃO ENCONTRADO'
    } 
  },
  '45510237015': {
    data: {
      status: 'NÃO ENCONTRADO'
    } 
  },
  '72795594099': {
    data: {
      status: 'CONECTADO'
    }
  },
  '60135869005': {
    data: {
      status: 'NÃO ENCONTRADO'
    } 
  },
  '32477771051': {
    data: {
      status: 'NÃO ENCONTRADO'
    } 
  },
  '73292476003': {
    data: {
      status: 'NÃO ENCONTRADO'
    } 
  },
  // Adicione mais CPFs e dados mockados conforme necessário
};
